import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function maxArrayLength(max: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value as unknown[];

        if (Array.isArray(value) && value.length > max) {
            return {
                maxSelected: {
                    max,
                    actual: value.length
                }
            };
        }

        return null;
    };
}
